import { Button } from "@coval/ui"
import {
  FileText,
  LockKeyhole,
  PanelLeftClose,
  PanelLeftOpen,
} from "lucide-react"

import { NewResourceButton } from "@/components/ResourceActionButton"

import type { Notebook } from "../../utils/reportTypes"
import { reportClass } from "./ReportStyles"

/** The toolbar's leading controls and where the open notebook is saved. */
export function ReportToolbarStatus({
  notebook,
  readonly,
  dirty,
  locked,
  showRecipe,
  onToggleRecipe,
  onNewNotebook,
}: {
  notebook: Notebook | null
  readonly: boolean
  dirty: boolean
  locked: boolean
  showRecipe: boolean
  onToggleRecipe: () => void
  onNewNotebook: () => void
}) {
  return (
    <div className={reportClass("toolbar-left")}>
      {!readonly && (
        <>
          <Button
            variant="ghost"
            icon
            tooltip={showRecipe ? "Hide recipe" : "Show recipe"}
            disabled={locked}
            onClick={onToggleRecipe}
          >
            {showRecipe ? <PanelLeftClose /> : <PanelLeftOpen />}
          </Button>
          <NewResourceButton
            resourceName="Notebook"
            variant="ghost"
            disabled={locked}
            onClick={onNewNotebook}
          />
        </>
      )}
      {readonly ? (
        <span>
          <LockKeyhole size={13} />
          Read-only · revision {notebook?.revision ?? "—"}
        </span>
      ) : (
        notebook && (
          <span>
            <FileText size={13} />
            {dirty
              ? "Unsaved changes"
              : `Saved to Notebooks · revision ${notebook.revision}`}
          </span>
        )
      )}
    </div>
  )
}
